// extracted by mini-css-extract-plugin
module.exports = {"chainSelector":"checkboxCustom_chainSelector__rE7IV","checkbox":"checkboxCustom_checkbox__x29vP","label":"checkboxCustom_label__77Hif"};